import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IGetProduktionsmalPlanResponse } from "~app/features/planera/model/IGetProduktionsmalPlanResponse";
import { IHandelssortimentsgrupp } from "~app/features/planera/model/IHandelssortimentsgrupp";
import { IProduktionsomraden } from "~app/features/planera/model/IProduktionsomraden";

@Injectable({
    providedIn: "root"
})
export class ProduktionsmalPlanService {
    private readonly apiClient = inject(ApiClientService);

    getProduktionsmalPlan(produktionsomradeId: number, period: Date): Observable<IProduktionsmalPlanResult> {
        const body = {
            produktionsomradeId: produktionsomradeId,
            period: period
        };

        return this.apiClient.post<any, IGetProduktionsmalPlanResponse>("/Planera/GetProduktionsmalPlan", body, true)
            .pipe(map(
                r => ({
                    period: period,
                    produktionsomradeId: produktionsomradeId,
                    responseDate: new Date(),
                    handelssortimentsgrupper: r.handelssortimentsgrupper

                })
            ));
    }

    getProduktionsomradeFromResult(produktionsomraden: IProduktionsomraden[], produktionsmalPlan: IProduktionsmalPlanResult) {
        if (produktionsomraden &&
            produktionsmalPlan &&
            produktionsmalPlan.produktionsomradeId) {
            return produktionsomraden.filter(p => p.id ===
                produktionsmalPlan.produktionsomradeId)[0];
        }
        return null;
    }
}

export interface IProduktionsmalPlanResult {
    period: Date;
    produktionsomradeId: number;
    responseDate: Date;
    handelssortimentsgrupper: IHandelssortimentsgrupp[];
}
